// outsource dependencies
import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      light: '#1769aa',
      main: '#1769aa',
      dark: 'rgb(17, 82, 147)',
    },
  },
});
